import promoVideoPoster from "assets/img/openwidget/thumbnail.png";
import promoVideoMp4 from "assets/video/open-widget.mp4";
import promoVideoWebm from "assets/video/open-widget.webm";
import { VideoPlayer } from "components/video-player/VideoPlayer";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const OpenWidgetPromoVideo = () => (
  <VideoPlayer poster={promoVideoPoster} withControls autoPlay loop>
    <>
      <source src={promoVideoWebm} type="video/webm" />
      <source src={promoVideoMp4} type="video/mp4" />
    </>
  </VideoPlayer>
);
